import { useApiStore } from '@/stores/apiStore';
import { SupportLinkApi } from '@/../generated-client/apis/SupportLinkApi';
import {
  SupportLinkCreate,
  SupportLinkDelete,
  SupportLinkUpdate,
} from '../../generated-client/models';

let supportLinkApi: SupportLinkApi | null = null;
let lastConfig: unknown = null;

function getSupportLinkApi(): SupportLinkApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (supportLinkApi === null || lastConfig !== apiConfig) {
    supportLinkApi = new SupportLinkApi(apiConfig);
    lastConfig = apiConfig;
  }

  return supportLinkApi;
}

export const getAllSupportLinks = async () => {
  const api = getSupportLinkApi();

  return await api.apiSupportLinkGetAllGet();
};

export const updateSupportLink = async (
  supportLink: SupportLinkUpdate | undefined,
) => {
  const api = getSupportLinkApi();

  return await api.apiSupportLinkUpdatePut({
    supportLinkUpdate: supportLink,
  });
};

export const deleteSupportLink = async (
  supportLink: SupportLinkDelete | undefined,
) => {
  const api = getSupportLinkApi();

  return await api.apiSupportLinkDeleteDelete({
    supportLinkDelete: supportLink,
  });
};

export const addSupportLink = async (
  supportLink: SupportLinkCreate | undefined,
) => {
  const api = getSupportLinkApi();

  return await api.apiSupportLinkAddPost({ supportLinkCreate: supportLink });
};
